enum AnnouncementType {
  NEW = 'new',
  IMPROVEMENT = 'improvement',
  FIX = 'fix',
}

export default AnnouncementType;
